import React from 'react'
import { Button } from '@mui/material'

interface SignupSubmitButtonProps {
    disabled: boolean
    children: React.ReactNode
}

// Shared shape for each step's primary submit action — only disabled and the label ever differ.
const SignupSubmitButton: React.FC<SignupSubmitButtonProps> = ({ disabled, children }) => (
    <Button type="submit" variant="contained" color="primary" size="large" disabled={disabled} fullWidth>
        {children}
    </Button>
)

export default SignupSubmitButton
